// extracted by mini-css-extract-plugin
export default {"metadataInputs":"MetaDataChange_metadataInputs__YDNV3"};